import { useEffect, useState } from "react";
import { timingSafeEqual } from "helpers";
import { useLocation, useNavigate } from "react-router-dom";

export const useHash = <HashString extends string>(
  supportedHashes: readonly HashString[],
): [hash: HashString | "", updateHash: (newHash: HashString) => void] => {
  const location = useLocation();
  const navigate = useNavigate();

  const [hash, setHash] = useState<HashString | "">(() => {
    const initialHash = supportedHashes.find(
      (supportedHash) => supportedHash === location.hash,
    );

    if (initialHash === undefined) {
      void navigate({ ...location, hash: "" }, { replace: true });
      return "";
    }

    return initialHash;
  });

  const hashChangeHandler = () => {
    setHash(
      supportedHashes.find(
        (supportedHash) => supportedHash === location.hash,
      ) || "",
    );
  };

  const params = new URLSearchParams(location.search);

  useEffect(() => {
    hashChangeHandler();
  }, [location.hash, hashChangeHandler]);

  const updateHash = (newHash: HashString) => {
    if (!timingSafeEqual(newHash, hash)) {
      params.set("page", "1");
      void navigate({
        ...location,
        search: `${params}`,
        hash: newHash,
      });
    }
  };

  return [hash, updateHash];
};
